/*
 * @Author: Gang Jiang 
 * @Date: 2024-09-14 15:15:14 
 * @Last Modified by: Gang Jiang
 * @Last Modified time: 2024-11-25 14:32:09
 */

<template>
  <div class="users">
    <div class="bread-crumb">
      Users
    </div>
    <h2>
      Users<a-button
        type="primary"
        @click="showNewUserModal = true"
      >
        + Add user
      </a-button>
    </h2>
    <div class="content">
      <a-spin :spinning="isLoading">
        <div class="header">
          <a-input-group compact>
            <a-select v-model:value="search.type">
              <a-select-option value="name">
                Name
              </a-select-option>
              <a-select-option value="email">
                Email
              </a-select-option>
            </a-select>
            <a-input
              v-model:value="search.keyword"
              placeholder="Please enter"
            />
          </a-input-group>
          <a-button
            class="do-search"
            type="primary"
            @click="doSearch()"
          >
            Search
          </a-button>
          <a-button @click="doSearch(false)">
            Reset
          </a-button>
        </div>
        <a-table
          :columns="columns"
          :data-source="userList"
          :pagination="pagination"
        >
          <template #headerCell="{ column }">
            <template v-if="column.key === 'operation'">
              <span> Operation </span>
            </template>
          </template>
          <template #bodyCell="{ column, record }">
            <template v-if="column.key === 'operation'">
              <a-popconfirm
                v-if="userList.length"
                :title="
                  'Sure to ' +
                    (record.state ? 'Disable' : 'Activate') +
                    ' ' +
                    record.name +
                    '?'
                "
                @confirm="() => changeUserState(record)"
              >
                <a href="javascript:;">{{
                  record.state ? 'Disable' : 'Activate'
                }}</a>
              </a-popconfirm>
              <a
                class="edit"
                href="javascript:;"
                @click="edit(record)"
              >Edit</a>
            </template>
            <template v-else-if="column.key === 'state'">
              <span
                :class="'state ' + (record.state ? 'active' : 'inactive')"
              >{{ record.state ? 'activated' : 'disabled' }}</span>
            </template>
          </template>
        </a-table>
      </a-spin>
    </div>
    <a-modal
      v-model:open="showNewUserModal"
      :title="(newUser.id ? 'Edit' : 'Add') + ' User'"
      @ok="addUser"
      @cancel="resetNewUserModal"
    >
      <a-form
        ref="formRef"
        :model="newUser"
        :validate-messages="validateMessages"
      >
        <a-form-item
          :name="['name']"
          label="User name"
          :rules="[{ required: true }]"
        >
          <a-input
            v-model:value="newUser.name"
            placeholder="Please enter"
          />
        </a-form-item>
        <a-form-item
          :name="['email']"
          label="Email"
          :rules="[{ type: 'email' }, { required: true }]"
        >
          <a-input
            v-model:value="newUser.email"
            placeholder="Please enter"
          />
        </a-form-item>
        <a-form-item
          :name="['email']"
          label="Password"
          :rules="[{ required: true }]"
        >
          <a-input
            v-model:value="newUser.password"
            placeholder="Please enter"
            type="password"
          />
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import { user } from '../server/index'

const columns = [
  {
    title: 'Name',
    dataIndex: 'name',
    key: 'name',
  },
  {
    title: 'Email',
    dataIndex: 'email',
    key: 'email',
  },
  {
    title: 'State',
    dataIndex: 'state',
    key: 'state',
  },
  {
    title: 'Operation',
    key: 'operation',
  },
]

export default {
  data() {
    return {
      isLoading: false,
      showNewUserModal: false,
      columns,
      search: {
        type: 'name',
        keyword: '',
      },
      newUser: {
        name: '',
        email: '',
        password: '',
      },
      userList: [],
      validateMessages: {
        required: '${label} is required!',
        types: {
          email: '${label} is not a valid email!',
        },
      },
      pagination: {
        current: 1,
        pageSize: 200,
        total: 0,
        onChange: (page) => {
          this.getList(page)
        },
      },
    }
  },
  mounted() {
    this.getList(1)
  },
  methods: {
    doSearch(isSearch = true) {
      if (isSearch) {
        if (this.search.keyword.trim().length) {
          this.getList(1)
        }
      } else {
        this.search = {
          type: 'name',
          keyword: ''
        }
        this.getList(1)
      }
    },
    changeUserState(userInstance) {
      user
        .changeState({ ...userInstance, state: userInstance.state ? 0 : 1 })
        .then((res) => {
          if (res.success) {
            this.getList(1)
          }
        })
    },
    getList(page) {
      const params = { page, size: this.pagination.pageSize }

      if (this.search.keyword.trim().length) {
        params[this.search.type] = this.search.keyword.trim();
      }

      this.isLoading = true

      user.getList(params).then((res) => {
        this.isLoading = false
        this.userList = res.data
        this.pagination.current = page

        if (page == 1) {
          this.pagination.total = res.total
        }
      })
    },
    edit(userInstance) {
      this.newUser = userInstance
      this.showNewUserModal = true
    },
    addUser() {
      if (this.$refs.formRef) {
        this.$refs.formRef
          .validate()
          .then(() => {
            console.log('Form validated successfully')
            // 验证通过，可以执行提交逻辑
            user[this.newUser.id ? 'changeState' : 'add'](this.newUser).then(
              (res) => {
                if (res.success) {
                  this.showNewUserModal = false
                  this.resetNewUserModal()
                  this.getList(1)
                }
              }
            )
          })
          .catch((error) => {
            console.log('Form validation failed:', error)
          })
      }
    },
    resetNewUserModal() {
      this.newUser = {
        name: '',
        email: '',
        password: '',
      }
    },
  },
}
</script>

<style lang="less" scoped>
.ant-list-item {
  padding-left: 20px;
}
.users {
  h2 {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .header {
    display: flex;
    padding: 20px;
    align-items: center;
    justify-content: right;
  }
  .do-search {
    margin: 0 10px;
  }
  :deep(.ant-input) {
    &-group {
      width: 240px;
    }
    width: 160px;
    text-align: left;
  }
}
.edit {
  margin-left: 10px;
}
.state {
  display: block;
  margin-left: 20px;
  position: relative;
  &:before {
    top: 50%;
    width: 6px;
    left: -13px;
    height: 6px;
    content: '';
    position: absolute;
    border-radius: 50%;
    transform: translateY(-50%);
    background-color: #52c41a;
  }
  &.inactive {
    &:before {
      background-color: #f00;
    }
  }
}
:deep(.ant-form-item-label) {
  width: 100px;
  text-align: right;
  margin-right: 6px;
}
</style>